import React from 'react';
import { Card, Typography, Box, Button, FormControl, Stack, MenuItem, InputLabel, Select } from "@mui/material";
import { getCurrentPeriodYear, getDatePeriodOptions } from "../../helper/DatePeriodHelper";

// const dateOptions = [
//     { label: 'Today', value: 'today' },
//     { label: 'Yesterday', value: 'yesterday' },
//     { label: 'Last 7 Days', value: 'last7days' },
//     { label: 'Last 30 Days', value: 'last30days' },
//     { label: 'This Month', value: 'thismonth' },
//     { label: 'Last Month', value: 'lastmonth' },
//     { label: 'Custom Range', value: 'custom' },
// ];

const DatePeriodOption = ({ value, onChange }) => {


    // };

    let dateOptions = getDatePeriodOptions(5);

    return (
        <Select sx={{fontSize:'10pt'}}
            labelId="date-period-select-label"
            id="date-period-select"
            value={value}
            
            onChange={e => onChange(e.target.value)}
            fullWidth
        >
            {dateOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </Select>
    );

    // return (
    //     <div>
            
    //         {/* <Sel */}
    //         {/* <MuiSelect
    //             id="date-period-select"
    //             value={value}
    //             onChange={e => onChange(e.target.value)}
    //             fullWidth
    //             variant="outlined"
    //             displayEmpty
    //         >
    //         </MuiSelect>
    //         <pre>Selected Value: {value} </pre> */}
    //     </div>
    // );

}
export default DatePeriodOption;